import { render, staticRenderFns } from "./CommodityDetail.vue?vue&type=template&id=6a728f87"
import script from "./CommodityDetail.vue?vue&type=script&lang=js"
export * from "./CommodityDetail.vue?vue&type=script&lang=js"
import style0 from "./CommodityDetail.vue?vue&type=style&index=0&id=6a728f87&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports